import { getFramework, IFramework } from '@/framework';

export class MouseHover {
    private framework: IFramework;
    private doubleClickTipVisible = true;
    private visibleEventName = 'mouse-hover-double-click-tip-visible-change';

    constructor(id: string) {
        this.framework = getFramework(id);
    }

    isDoubleClickTipVisible() {
        return this.doubleClickTipVisible;
    }

    /** 显示双击文案提示 */
    showDoubleClickTip() {
        this.doubleClickTipVisible = true;
        this.framework.events.emit(this.visibleEventName, true);
    }

    /** 隐藏双击文案提示 */
    hideDoubleClickTip() {
        this.doubleClickTipVisible = false;
        this.framework.events.emit(this.visibleEventName, false);
    }

    /** 监听双击文案提示可见性变化 */
    onVisibleChange(callback: (visible: boolean) => void) {
        const handler = this.framework.events.on(this.visibleEventName, callback);

        return () => {
            this.framework.events.off(handler);
        };
    }
}
